import { JSX, Suspense } from "react";

import { LinearProgress } from "@mui/material";
import { withSentryReactRouterV7Routing } from "@sentry/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./scss/App.scss";

import ErrorHandler from "./components/ErrorHandler/ErrorHandler";
import { ConsentProvider } from "./components/GoogleAnalytics/ConsentProvider";
import CookieBanner from "./components/GoogleAnalytics/CookieBanner";
import GlobalLayout from "./layout/GlobalLayout";
import MainLayout from "./layout/MainLayout";
import { APP_BASENAME } from "./lib/config.helper";
import AuthRedirect from "./pages/AuthRedirect";
import CenterDashboard from "./pages/CenterDashboard/CenterDashboard";
import CenterDashboardPage from "./pages/CenterDashboard/CenterDashboardPage";
import CenterRegionDashboard from "./pages/CenterRegionDashboard/CenterRegionDashboard";
import CenterRegionDashboardPage from "./pages/CenterRegionDashboard/CenterRegionDashboardPage";
import ExtendedAnalyticsDashboardSelectionPage from "./pages/ExtendedAnalytics/ExtendedAnalyticsDashboardSelectionPage";
import ExtendedAnalyticsViewPage from "./pages/ExtendedAnalytics/ExtendedAnalyticsViewPage";
import FilePreviewPage from "./pages/Files/FilePreviewPage";
import FilesListPage from "./pages/Files/FilesListPage";
import FilesPage from "./pages/Files/FilesPage";
import KeycloakSignIn from "./pages/KeycloakSignIn";
import NotFound from "./pages/NotFound";
import Redirect from "./pages/Redirect";
import ShopDashboard from "./pages/ShopDashboard/ShopDashboard";
import ShopDashboardPage from "./pages/ShopDashboard/ShopDashboardPage";
import ShopRegionDashboard from "./pages/ShopRegionDashboard/ShopRegionDashboard";
import ShopRegionDashboardPage from "./pages/ShopRegionDashboard/ShopRegionDashboardPage";
import StationDashboard from "./pages/StationDashboard/StationDashboard";
import StationDashboardPage from "./pages/StationDashboard/StationDashboardPage";
import StationRegionDashboard from "./pages/StationRegionDashboard/StationRegionDashboard";
import StationRegionDashboardPage from "./pages/StationRegionDashboard/StationRegionDashboardPage";
import ProtectedRoute from "./route/ProtectedRoute";
import "./assets/fonts/fontEvents/css/fontevents.css";

const SentryRoutes = withSentryReactRouterV7Routing(Routes);

function App(): JSX.Element {
  return (
    <BrowserRouter basename={APP_BASENAME === "" ? undefined : APP_BASENAME}>
      <ConsentProvider>
        <ErrorHandler>
          <Suspense fallback={<LinearProgress />}>
            <SentryRoutes>
              <Route path='/login' element={<KeycloakSignIn />} />
              <Route path='/authredirect' element={<AuthRedirect />} />
              <Route element={<ProtectedRoute />}>
                <Route path='/' element={<MainLayout />}>
                  <Route index element={<Redirect />} />
                  <Route element={<GlobalLayout />}>
                    <Route path='/center-region-dashboard' element={<CenterRegionDashboardPage />}>
                      <Route path=':locationId' element={<CenterRegionDashboard />} />
                    </Route>
                    <Route path='/center-dashboard' element={<CenterDashboardPage />}>
                      <Route path=':locationId' element={<CenterDashboard />} />
                    </Route>
                    <Route path='/shop-region-dashboard' element={<ShopRegionDashboardPage />}>
                      <Route path=':locationId' element={<ShopRegionDashboard />} />
                    </Route>
                    <Route path='/shop-dashboard' element={<ShopDashboardPage />}>
                      <Route path=':locationId' element={<ShopDashboard />} />
                    </Route>
                    <Route path='/station-region-dashboard' element={<StationRegionDashboardPage />}>
                      <Route path=':locationId' element={<StationRegionDashboard />} />
                    </Route>
                    <Route path='/station-dashboard' element={<StationDashboardPage />}>
                      <Route path=':locationId' element={<StationDashboard />} />
                    </Route>
                  </Route>
                  <Route path='/files' element={<FilesPage />}>
                    <Route path=':locationId/:fileId/:fileName' element={<FilePreviewPage />} />
                    <Route path=':locationId' element={<FilesListPage />} />
                  </Route>
                  <Route path='/extended-analytics' element={<ExtendedAnalyticsDashboardSelectionPage />} />
                  <Route path='/extended-analytics/:id' element={<ExtendedAnalyticsViewPage />} />
                </Route>
              </Route>
              <Route path='*' element={<NotFound />} />
            </SentryRoutes>
            <CookieBanner />
          </Suspense>
        </ErrorHandler>
      </ConsentProvider>
    </BrowserRouter>
  );
}
export default App;
